import { Tab, Tabs, TabsProps } from "@material-ui/core"
import {
  ArrowBackIos as ArrowBackIosIcon,
  ArrowForwardIos as ArrowForwardIosIcon,
} from "@material-ui/icons"
import React from "react"
import { NavLink, NavLinkProps, useLocation } from "react-router-dom"
import routes from "routes"
import styled from "styled-components"
import { Font, STEPS_TEXT } from "../constants"

const StyledTabsContainer = styled.div`
  background: ${(p) => p.theme.colors.lightGrey};
  z-index: 1;
  ${(p) => p.theme.breakpoints.up("md")} {
    border-bottom: 1px solid ${(p) => p.theme.colors.borderGrey};
  }

  ${(p) => p.theme.breakpoints.down("sm")} {
    position: fixed;
    width: 100%;
  }
`

type StyledTabsProps = React.FC<
  TabsProps<"nav", { component: "nav"; $page: string }>
>

const StyledTabs = styled<StyledTabsProps>(Tabs)`
  ${(p) => p.theme.breakpoints.up("md")} {
    max-width: 450px;
    margin: 0 auto;
  }
`
type StyledStepNavLinkProps = React.FC<NavLinkProps & { hidden: boolean }>

const StyledStepNavLink = styled<StyledStepNavLinkProps>(NavLink)`
  display: ${(p) => (p.hidden ? "none" : "flex")};
  color: ${(p) => p.theme.palette.text.secondary};
  letter-spacing: 0.5px;
  text-decoration: none;
  min-width: 40px;

  &.MuiTab-root-12 {
    padding: 6px 0;
  }

  ${(p) => p.theme.breakpoints.up("md")} {
    min-width: 60px;
  }

  ${(p) => p.theme.breakpoints.down("md")} {
    &.MuiTab-root-46,
    &.MuiTab-root-960 {
      padding: 6px 0;
    }
  }

  &.active {
    font-weight: bold;
    color: ${(p) => p.theme.palette.text.primary};
  }
`
const StyledStepText = styled.span<{ $index: number }>`
  font-family: ${Font.OENaPro};
  font-size: 12px;
  ${(p) => p.$index === 0 && "min-width:56px;"}
`

const StyledArrowForwardIosIcon = styled(ArrowForwardIosIcon)`
  position: relative;
  color: ${(p) => p.theme.palette.text.primary};
`

const StyledArrowBackIosIcon = styled(ArrowBackIosIcon)`
  position: relative;
  color: ${(p) => p.theme.palette.text.primary};
`

const StyledTab = styled(Tab)<{ component: any; to: string }>`
  opacity: 1;

  svg {
    height: 11px;
  }
`

const StyledNameTab = styled(Tab)<{
  component: any
  to: string
}>``

const Steps = () => {
  const { pathname } = useLocation()

  const activeStepIndex = routes.array.findIndex((r) => r.path === pathname)

  const countActiveSteps = routes.array.reduce((a, b) => {
    if (b.showStep) return a + 1
    return a
  }, 0)

  return (
    <StyledTabsContainer>
      <StyledTabs
        value={pathname === "/" ? routes.array[0].path : pathname}
        aria-label="תפריט ניווט של שלבי הרכבת רכב"
        indicatorColor="primary"
        variant="fullWidth"
        component="nav"
        role="navigation"
        TabIndicatorProps={{ style: { bottom: "8px" } }}
        $page={pathname}
      >
        <StyledTab
          component={StyledStepNavLink}
          to={
            activeStepIndex > 0
              ? routes.array[activeStepIndex - 1].path
              : routes.array[0].path
          }
          value="back"
          aria-current="step"
          id="steps-nav-tab-back-arrow"
          aria-controls="steps-nav-tabpanel-forward-arrow"
          label={<StyledArrowForwardIosIcon />}
          disabled={activeStepIndex === 0}
        />

        {routes.array.map((route, i) => {
          return (
            <StyledNameTab
              key={route.path}
              component={StyledStepNavLink}
              hidden={!route.showStep}
              to={route.path}
              value={route.path}
              aria-current="step"
              id={`steps-nav-tab-${i}`}
              aria-controls={`steps-nav-tabpanel-${i}`}
              label={
                <StyledStepText $index={i}>{STEPS_TEXT[i]}</StyledStepText>
              }
              disabled={false}
              tabIndex={0}
            />
          )
        })}

        <StyledTab
          component={StyledStepNavLink}
          to={
            activeStepIndex !== routes.array.length - 1
              ? routes.array[activeStepIndex + 1].path
              : routes.array[activeStepIndex].path
          }
          value="forwards"
          aria-current="step"
          id="steps-nav-tab-left-arrow"
          aria-controls="steps-nav-tabpanel-left-arrow"
          label={<StyledArrowBackIosIcon />}
          disabled={activeStepIndex === countActiveSteps - 1}
        />
      </StyledTabs>
    </StyledTabsContainer>
  )
}

export default Steps
